export class CheckpointState {
    constructor(id, position, isCompleted, isVisible, isAccesible) {
        this.id = id;
        this.position = position;
        this.isCompleted = isCompleted;
        this.isVisible = isVisible;
        this.isAccesible = isAccesible;
    }
    setVisible(state) {
        if (this.isVisible.value === state) {
            return;
        }
        this.isVisible.set(state);
    }
    setAccesible(state) {
        if (this.isAccesible.value === state) {
            return;
        }
        this.isAccesible.set(state);
    }
}
